import { gql } from '@apollo/client';

export default gql`
  mutation DeleteVoucher($voucherAlias: String!) {
    deleteVoucher(voucherAlias: $voucherAlias)
  }
`;
